import React, { useState } from 'react';
import Button from '@atlaskit/button/new';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import ModalDialog, { ModalBody, ModalFooter } from '@atlaskit/modal-dialog';
import { Text } from '@atlaskit/primitives';
import ShortcutScope from '@atlassian/jira-common-components-keyboard-shortcuts/src/shortcut-scope.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { PriorityModalHeader } from '../../../common/modal-header';
import type { Priority } from '../../../common/types';
import { messages } from './messages';

type Props = {
	priority: Priority;
	onClose: () => void;
	onConfirm: () => void;
};

export const DeletePriorityModal = ({ priority, onClose, onConfirm }: Props) => {
	const { formatMessage } = useIntl();
	const [isLoading, setIsLoading] = useState<boolean>(false);

	return (
		// Todo remove ShortcutScope and ModalDialog in cleanup of jsw_priority_modals_admin_page
		<ShortcutScope>
			<ModalDialog width="small" onClose={onClose}>
				<PriorityModalHeader
					testId="admin-pages-priorities.ui.priority-modals.delete-modal.priority-table-modal-title"
					appearance="warning"
					onClose={onClose}
					title={formatMessage(messages.deleteModalTitle)}
				/>
				<ModalBody>
					<Text as="p">
						{formatMessage(messages.deleteModalBody, {
							priorityName: priority.name,
						})}
					</Text>
				</ModalBody>
				<ModalFooter>
					<Button appearance="subtle" onClick={onClose} type="button">
						{formatMessage(messages.cancelButton)}
					</Button>
					<Button
						appearance="warning"
						type="submit"
						isLoading={isLoading}
						onClick={() => {
							setIsLoading(true);
							onConfirm();
						}}
					>
						{formatMessage(messages.confirmButton)}
					</Button>
				</ModalFooter>
			</ModalDialog>
		</ShortcutScope>
	);
};
